import { useCampaignStatusToggle } from 'components/CampaignsDashboard/hooks/useCampaignStatusToggle';

import { getIsInsufficientBalance } from 'components/CampaignsDashboard/utils/utils';

import { CampaignDetails, CampaignStatistics, DashboardCampaign } from 'store/models/campaignsDashboard';
import { useSelector } from 'store/utils';

interface CampaignRowModel {
    campaignStatistics?: CampaignStatistics;
    campaignDetails?: CampaignDetails;
    isStatisticsLoading: boolean;
    isDetailsLoading: boolean;
    isInsufficientBalance: boolean;
    onToggleStatus: () => void;
    isStatusToggleLoading: boolean;
}

export const useCampaignRowModel = (campaign: DashboardCampaign): CampaignRowModel => {
    const campaignStatistics = useSelector(
        ({ campaignsDashboard }) => campaignsDashboard.campaignsStatistics?.[campaign.id]
    );
    const campaignDetails = useSelector(({ campaignsDashboard }) => campaignsDashboard.campaignsDetails?.[campaign.id]);
    const isStatisticsLoading = useSelector(
        ({ campaignsDashboard }) => campaignsDashboard.isCampaignsStatisticsLoading
    );
    const isDetailsLoading = useSelector(({ campaignsDashboard }) => campaignsDashboard.isCampaignsDetailsLoading);
    const realBalance = useSelector((state) => state.balance.realBalance);

    const isInsufficientBalance = getIsInsufficientBalance(realBalance, campaign.bid, campaign.frontendStatus);
    const { onToggleStatus, isStatusToggleLoading } = useCampaignStatusToggle(campaign, isInsufficientBalance);

    return {
        campaignStatistics,
        campaignDetails,
        isStatisticsLoading,
        isDetailsLoading,
        isInsufficientBalance,
        onToggleStatus,
        isStatusToggleLoading,
    };
};
